const WS_URL = 'wss://wss1.bithumb.com/stream'
const RECONNECT_MS = 5000
const KRW_MARKET_CODE = 'C0100'
const USDT_COIN_CODE = 'C0866'

const SUBSCRIBE_PAYLOAD = JSON.stringify({
  type: 'SUBSCRIBE',
  events: [
    { type: 'rqc', filters: [['C0100'], ['C0101']] },
    { type: 'dts', filters: [['C0100'], ['C0101']] },
    { type: 'ost', filters: ['C0866', 'C0100'] },
    { type: 'trs', filters: ['C0866', 'C0100'] },
    { type: 'obu', filters: ['C0100', 'C0866'] }
  ]
})

let state = {
  rate: null,
  loading: false,
  error: '',
  updatedAt: null,
  connected: false
}
const listeners = new Set()
let socket = null
let reconnectTimer = null
let shouldConnect = false

function notify () {
  const snapshot = { ...state }
  listeners.forEach(fn => {
    try {
      fn(snapshot)
    } catch (err) {
      // ignore listener errors
    }
  })
}

/** @param {unknown} message */
export function parseUsdtKrwPrice (message) {
  if (!message || typeof message !== 'object') return null
  const msg = /** @type {{ type?: string, content?: { m?: string, c?: string, p?: string|number } }} */ (message)
  if (msg.type !== 'rqc' || !msg.content) return null
  if (msg.content.c !== USDT_COIN_CODE || msg.content.m !== KRW_MARKET_CODE) return null
  const price = Number(msg.content.p)
  if (!Number.isFinite(price) || price <= 0) return null
  return price
}

function scheduleReconnect () {
  if (!shouldConnect || reconnectTimer) return
  reconnectTimer = window.setTimeout(() => {
    reconnectTimer = null
    connect()
  }, RECONNECT_MS)
}

function connect () {
  if (!shouldConnect || socket) return

  if (!state.rate) {
    state.loading = true
    state.error = ''
    notify()
  }

  try {
    socket = new WebSocket(WS_URL)
  } catch (err) {
    if (!state.rate) {
      state.loading = false
      state.error = '빗썸 환율 연결에 실패했습니다.'
      notify()
    }
    scheduleReconnect()
    return
  }

  socket.onopen = () => {
    state.connected = true
    state.error = ''
    notify()
    socket.send(SUBSCRIBE_PAYLOAD)
  }

  socket.onmessage = (event) => {
    let message
    try {
      message = JSON.parse(event.data)
    } catch (err) {
      return
    }
    const price = parseUsdtKrwPrice(message)
    if (price == null) return
    state.rate = price
    state.loading = false
    state.error = ''
    state.updatedAt = Date.now()
    notify()
  }

  socket.onerror = () => {
    if (!state.rate) {
      state.error = '빗썸 환율 연결에 실패했습니다.'
      notify()
    }
  }

  socket.onclose = () => {
    socket = null
    state.connected = false
    if (!state.rate) {
      state.loading = false
      if (!state.error) state.error = '빗썸 환율 연결이 끊어졌습니다.'
      notify()
    }
    if (shouldConnect) scheduleReconnect()
  }
}

function disconnect () {
  shouldConnect = false
  if (reconnectTimer) {
    window.clearTimeout(reconnectTimer)
    reconnectTimer = null
  }
  if (socket) {
    const ws = socket
    socket = null
    ws.onopen = null
    ws.onmessage = null
    ws.onerror = null
    ws.onclose = null
    try {
      ws.close()
    } catch (err) {
      // ignore close errors
    }
  }
  state.connected = false
}

function startConnection () {
  shouldConnect = true
  connect()
}

/** @returns {function} unsubscribe */
export function subscribeBithumbUsdtRate (callback) {
  listeners.add(callback)
  callback({ ...state })
  if (listeners.size === 1) startConnection()
  return () => {
    listeners.delete(callback)
    if (listeners.size === 0) disconnect()
  }
}

export function getBithumbUsdtRateState () {
  return { ...state }
}
